<template>

  <div>
    <vue-good-table
      :columns="columns"
      :rows="totalsRow"
      class="hide-table-header"
      :pagination-options="{ enabled: false }"
    >
      <template slot="table-row" slot-scope="props">
        <div v-if="props.column.field === 'docDate'" class="text-right">
            <header-with-tooltip :tooltipText="totalAmountToolTip">Total  </header-with-tooltip>
        </div>
      </template>
    </vue-good-table>
  </div>

</template>

<script>
import { VueGoodTable } from "vue-good-table";
import HeaderWithTooltip from "../HeaderWithTooltip";


export default {
  name: "TotalForCurrentView",
  components: {HeaderWithTooltip, VueGoodTable },
  props: ["columns","isSortedArraySum","totalValue","sortedArraySum"],
  computed: {
    totalsRow() {
      return [
        {
          "purchaseOrderAmountinUSD": `<span><strong>USD </strong></span> ${!this.isSortedArraySum ? this.totalValue : this.sortedArraySum}`
        }
      ]
    },
    totalAmountToolTip(){
      return `Total amount for current view`
    }
  }


}
</script>

<style scoped>
.vgt-wrap >>> .vgt-table thead {
  visibility: hidden;
  line-height: 0px !important;
}

.vgt-wrap >>> .vgt-table thead tr th{
  padding: 0px !important;
}
</style>